var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLoading
    ? _c(
        "div",
        {
          staticClass:
            "leo-fixed leo-top-0 leo-left-0 leo-right-0 leo-bottom-0 leo-w-full leo-h-screen leo-z-5 leo-overflow-hidden leo-bg-grey-600 leo-opacity-75 leo-flex leo-flex-col leo-items-center leo-justify-center",
          class: { "loading-white": _vm.displayWhiteBackground },
        },
        [_c("leo-loader")],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }